<template>
  <div>
    <logo class="logo"/>
    <div class="mt-3">Page not found</div>
  </div>
</template>

<script>

import Logo from "../../components/global/Logo";
export default {
  components: {Logo},
  mounted() {
    this.$router.push('/')
  }
}
</script>
